import * as React from "react";
const SvgBatteryCharging20 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M11 20v-3H7v5h10v-5h-4.4L11 20z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.3,
  d: "M17 4h-3V2h-4v2H7v13h4v-2.5H9L13 7v5.5h2L12.6 17H17V4z",
  fill: "currentColor"
}));
export default SvgBatteryCharging20;